import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { TellentAppsDataService } from '@core/tellent-data';
import { TellentHttpApiService } from '@core/tellent-http-legacy';
import { GrowRole } from '@core/tellent-skills-types';
import { SeatKind } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class GrowRolesHttpClient {
  private readonly httpApi = inject(TellentHttpApiService);
  private readonly growApp$ = inject(TellentAppsDataService).getAppBySeatKind(SeatKind.Grow);

  public fetchRoles(): Observable<GrowRole[]> {
    return this.growApp$.pipe(
      take(1),
      switchMap(app =>
        this.httpApi
          .get(`/positions/app/${app.guid}/roles`, null, { skipCompany: true })
          .pipe(map((response: { roles: GrowRole[] }) => response.roles)),
      ),
    );
  }
}
